import CancelableAxiosInstance from "./CancelableAxiosInstance";

export default abstract class CancelableApi {
  protected client: CancelableAxiosInstance;

  protected constructor(client: CancelableAxiosInstance) {
    this.client = client;
  }

  /**
   * Cancel all pending requests emitted by this instance of CancelableApi
   */
  cancel(): void {
    this.client.cancelRequests();
  }
}
